module.exports = __webpack_public_path__ + "img/category-shose.3f77a7e6.png";